import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AppProviders } from './providers'
import { AppShell } from './layout/AppShell'
import { ChatView } from '@/features/chat/ChatView'
import { HistoryView } from '@/features/history/HistoryView'
import { SavedView } from '@/features/saved/SavedView'
import { DiagnosticsView } from '@/features/diagnostics/DiagnosticsView'
import { SettingsView } from '@/features/settings/SettingsView'

export function App() {
  return (
    <AppProviders>
      <BrowserRouter>
        <Routes>
          <Route element={<AppShell />}>
            <Route index element={<ChatView />} />
            <Route path="history" element={<HistoryView />} />
            <Route path="saved" element={<SavedView />} />
            <Route path="diagnostics" element={<DiagnosticsView />} />
            <Route path="settings" element={<SettingsView />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AppProviders>
  )
}
